// Module
var code = "<span ng-message=\"pattern\" class=\"error color-error\"> <span class=\"label__password-requirements\"> Password Requirements: <ul> <li>At least 8 characters</li> <li>Both upper and lower case letters</li> <li>At least one number</li> </ul> </span> </span> ";
// Exports
module.exports = code;